export const accountSwitchStorageKey = 'cash-web-account-switch'

export const notifyAccountSwitch = () => {
  try {
    window.localStorage.setItem(accountSwitchStorageKey, String(Date.now()))
  } catch {
    // A notification failure must not interrupt a switch that already succeeded.
  }
}
